"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WHITELABEL_SELECTOR_CLASS = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _rgba = _interopRequireDefault(require("polished/lib/color/rgba"));
var _appTheme = _interopRequireDefault(require("../appTheme"));
var _variables = require("../css/variables");
const size = '28px';
const sizeSmall = '18px';
const thickness = '4px';
const thicknessSmall = '2px';
const duration = '1.2s';
const background = (0, _rgba.default)('black', 0.1);
const foreground = _appTheme.default.colors.pink;
const EXTERNAL_NAME = 'loading-spinner';
const WHITELABEL_SELECTOR_CLASS = exports.WHITELABEL_SELECTOR_CLASS = `anvil-${EXTERNAL_NAME}`;
const getCssValue = ({
  variableName,
  value
}) => {
  return (0, _variables.createVariablizedCss)({
    variablePrefix: EXTERNAL_NAME,
    variableName,
    value
  });
};
const LoadingSpinner = _styledComponents.default.div.attrs({
  className: `loading-spinner ${WHITELABEL_SELECTOR_CLASS}`,
  'data-cy': 'loadingSpinner'
}).withConfig({
  shouldForwardProp: prop => ['getDefaultColor', 'block', 'small', 'color'].indexOf(prop) === -1
})`
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  text-indent: -9999em;
  border-top: ${getCssValue({
  variableName: 'thickness',
  value: thickness
})}
    solid ${background};
  border-right: ${getCssValue({
  variableName: 'thickness',
  value: thickness
})}
    solid ${background};
  border-bottom: ${getCssValue({
  variableName: 'thickness',
  value: thickness
})}
    solid ${background};
  border-left: ${getCssValue({
  variableName: 'thickness',
  value: thickness
})}
    solid ${({
  getDefaultColor
}) => getCssValue({
  variableName: 'color',
  value: getDefaultColor ? getDefaultColor(foreground) : foreground
})};
  flex-shrink: 0;
  flex-grow: 0;

  transform: translateZ(0);
  animation: spinSpinner ${duration} infinite linear;
  vertical-align: middle;

  &,
  &:after {
    border-radius: 50%;
    width: ${getCssValue({
  variableName: 'size',
  value: size
})};
    height: ${getCssValue({
  variableName: 'size',
  value: size
})};
  }

  ${({
  block
}) => block && `
    display: block;
  `}

  ${({
  small
}) => small && `
    &,
    &::after {
      width: ${getCssValue({
  variableName: 'size',
  value: sizeSmall
})};
      height: ${getCssValue({
  variableName: 'size',
  value: sizeSmall
})};
      border-width: ${getCssValue({
  variableName: 'thickness',
  value: thicknessSmall
})};
    }
  `}

  ${({
  color,
  getDefaultColor
}) => color && `
    border-left-color: ${getCssValue({
  variableName: 'color',
  value: getDefaultColor ? getDefaultColor(color) : color
})};
  `}

  @keyframes spinSpinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
LoadingSpinner.defaultProps = {
  small: false,
  block: false
};
LoadingSpinner.propTypes = {
  small: _propTypes.default.bool,
  block: _propTypes.default.bool,
  color: _propTypes.default.string
};
var _default = exports.default = LoadingSpinner;